import { Loader } from '@mantine/core';
import classnames from 'classnames';
import { Message, Wrapper } from './LoaderPage.style';

export type LoaderPageProps = {
  color?: string;
  children?: React.ReactNode;
  noFlex?: boolean;
};

export function LoaderPage(props: LoaderPageProps) {
  const { color, noFlex } = props;

  function renderMessage() {
    if (!props.children) return null;

    return <Message>{props.children}</Message>;
  }

  const className = classnames('LoaderPage-wrapper', {
    noFlex,
  });

  return (
    <Wrapper className={className} data-testid='LoaderPage-wrapper'>
      {renderMessage()}
      <Loader color={color} />
    </Wrapper>
  );
}

export default LoaderPage;
